import {inject, Injectable} from '@angular/core';
import {RecordsTableService} from "../../../../services/records-table.service";
import {RecordTableColumnParams, RecordTableParams} from "../../../../types/records-table.types";
import {resources} from "../../../../models/resource/resources";
import {defaultRecordTableParams} from "../../../../models/default-record-table-params";

@Injectable({
  providedIn: 'root'
})
export class RecordsAdvertisementPackagesService {
  private recordsTableService: RecordsTableService = inject(RecordsTableService);

  public async getRecordsTableParams(): Promise<RecordTableParams> {
    return  await this.recordsTableService.getRecordTableColumnsParams(resources['record-calendars'].path).catch(() => defaultRecordTableParams);
  }

  public getRecordTableColumnParams(recordsTableParams: RecordTableParams): Array<RecordTableColumnParams> {
    return recordsTableParams.fields
      .filter(field => !field.omit && field.type !== 'MODAL')
      .map(field => ({
        ...field,
        hiddenGroup: false,
        hiddenGroupPlaceholder: false
      }));
  }
}
